import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { Sidebar } from '../../core/services/sidebar';
import { Header } from '../../core/services/header';

type TabType = 'Transactions' | 'Updates';
type NotificationType = 'transactions' | 'updates';

interface NotificationItem {
  type: NotificationType;
  title: string;
  description: string;
  time: string;
  status: 'read' | 'unread';
  date: string;
  details:  string
}

interface NotificationGroup {
  dateLabel: string;
  date: string;
  notifications: NotificationItem[];
}


@Component({
  selector: 'app-notifications',
  imports: [TranslatePipe, CommonModule,],
  templateUrl: './notifications.html',
  styleUrl: './notifications.css'
})
export class Notifications {
  tabsList = ['Transactions', 'Updates'] as const;
  selectedTab: TabType = 'Transactions';

  notificationList: NotificationGroup[] = [
    {
      dateLabel: "Today",
      date: "2025-10-14",
      notifications: [
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "🎉You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "Efawateercom - Postpaid",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "🎉 You’ve paid multiple bills for 230.000 JOD to Electric home, Internet home",
          type: "updates",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
      ]
    },
    {
      dateLabel: "22 Apr 2025",
      date: "2025-10-14",
      notifications: [
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "🔔 You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "🔔 You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "🎉 You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
      ]
    },
    {
      dateLabel: "19 Apr 2025",
      date: "2025-10-14",
      notifications: [
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
      ]
    },
    {
      dateLabel: "19 Jun 2025",
      date: "2025-10-14",
      notifications: [
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "transactions",
          status: 'read',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
        {
          title: "CliQ",
          time: "4:35 PM",
          date: '25 Apr 2025, 2:39 PM',
          description: "You’ve requested 10.000 JOD to Abdoullah Jabor",
          type: "updates",
          status: 'unread',
          details: 'Your money request has been sent successfully. You’ll be notified once it’s approved or declined.'
        },
      ]
    },
  ];

  filteredNotificationList: NotificationGroup[] = [];
  activeNotification: NotificationItem | null = null;


  constructor(
    private sidebarService: Sidebar,
    private headerService: Header
  ) { }

  ngOnInit() {
    this.sidebarService.setLinks([
      {
        label: 'SIDEBAR.BACK_TO_HOME',
        route: '/',
        iconPath: 'assets/icons/arrow-blue.svg',
        variant: 'outlined'
      },
    ]);

    this.headerService.updateConfig({
      title: 'HEADER_TITLES.NOTIFICATION',
      showNotifications: false
    });

    this.applyFilterAndSetDefault();

  }

  selectTab(type: TabType) {
    this.selectedTab = type;
    this.applyFilterAndSetDefault();
  }


  applyFilterAndSetDefault() {
    const tabType: NotificationType =
      this.selectedTab === 'Transactions' ? 'transactions' : 'updates';

    if (this.notificationList.length === 0) {
      this.filteredNotificationList = [];
      this.activeNotification = null;
      return;
    }

    this.filteredNotificationList = this.notificationList
      .map((group: NotificationGroup) => ({
        ...group,
        notifications: group.notifications.filter(
          (n: NotificationItem) => n.type === tabType
        )
      }))
      .filter(group => group.notifications.length > 0);

    this.activeNotification =
      this.filteredNotificationList.length > 0
        ? this.filteredNotificationList[0].notifications[0]
        : null;
  }

  selectNotification(tx: any) {
    this.activeNotification = tx;

    if (tx.status === 'unread') {
      tx.status = 'read';
    }
  }

}
